import React, { useState, useEffect } from "react";

const projects = [
    {
        title: "Azila Mansion",
        type: "Luxury Residences, Modern Homes",
        location: "Dubai Marina",
        price: "From $290k",
        client: "RC Builders",
        year: "15 Oct 2019",
        duration: "5Y, 3M",
        image: "/assets/portfolio/02.webp",
    },
    {
        title: "Skyline Towers",
        type: "Commercial High-Rise",
        location: "Downtown Dubai",
        price: "From $500k",
        client: "UrbanX",
        year: "10 Jan 2020",
        duration: "4Y, 6M",
        image: "/assets/portfolio/03.webp",
    },
    {
        title: "Palm Villas",
        type: "Luxury Villas",
        location: "Palm Jumeirah",
        price: "From $750k",
        client: "Oceanic Group",
        year: "22 Aug 2021",
        duration: "3Y",
        image: "/assets/portfolio/04.webp",
    },
    {
        title: "Desert Oasis",
        type: "Residential Complex",
        location: "Dubai Hills",
        price: "From $420k",
        client: "Desert Developers",
        year: "5 Mar 2022",
        duration: "2Y, 8M",
        image: "/assets/portfolio/17.webp",
    },
];

export default function ProjectCarousel() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [itemsToShow, setItemsToShow] = useState(3);

    // Handle responsive behavior
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 640) {
                setItemsToShow(1);
            } else if (window.innerWidth < 1024) {
                setItemsToShow(2);
            } else {
                setItemsToShow(3);
            }
        };

        handleResize(); // Set initial value
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const nextSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex >= projects.length - itemsToShow ? 0 : prevIndex + 1
        );
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex <= 0 ? projects.length - itemsToShow : prevIndex - 1
        );
    };

    const goToSlide = (index) => {
        setCurrentIndex(index);
    };

    // Auto-play functionality
    useEffect(() => {
        const interval = setInterval(() => {
            nextSlide();
        }, 3500);

        return () => clearInterval(interval);
    }, [currentIndex, itemsToShow]);

    return (
        <div className="my-10 px-4 mx-auto">
            <div className="text-center mb-8">
                <h3 className="text-[#00A3A1] text-lg font-semibold uppercase">
                    Recent Projects
                </h3>
                <h2 className="text-[#fff] text-3xl font-bold">
                    Our Completed Projects
                </h2>
            </div>

            {/* Carousel Container */}
            <div className="relative">
                {/* Navigation Arrows */}
                <button
                    onClick={prevSlide}
                    className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-gray-200 rounded-full p-2 shadow-md hover:bg-gray-100 transition-colors -left-4"
                    aria-label="Previous slide"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                </button>

                <button
                    onClick={nextSlide}
                    className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white rounded-full p-2 shadow-md hover:bg-gray-100 transition-colors -right-4"
                    aria-label="Next slide"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                </button>

                {/* Carousel Items */}
                <div className="overflow-hidden">
                    <div
                        className="flex transition-transform duration-500 ease-in-out"
                        style={{ transform: `translateX(-${currentIndex * (100 / itemsToShow)}%)` }}
                    >
                        {projects.map((project, index) => (
                            <div
                                key={index}
                                className="px-3 flex-shrink-0"
                                style={{ width: `${100 / itemsToShow}%` }}
                            >
                                <div className="relative rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                                    <img
                                        src={project.image}
                                        alt={project.title}
                                        className="w-full h-80 object-cover"
                                    />

                                    {/* Overlay Card */}
                                    <div className="absolute bottom-4 left-4 right-4 bg-white/60 p-4 rounded-lg shadow-md backdrop-blur-sm">
                                        <h3 className="text-lg font-bold text-gray-800">{project.title}</h3>
                                        <p className="text-sm text-gray-600">{project.type}</p>
                                        {/* <span className="inline-block mt-2 px-3 py-1 text-xs bg-gray-100 border rounded text-gray-700">
                                            📍 {project.location}
                                        </span> */}

                                        <div className="grid grid-cols-2 gap-2 mt-3 text-sm">
                                            <p className="text-gray-700">
                                                <span className="font-semibold">Price:</span> {project.price}
                                            </p>
                                            <p className="text-gray-700">
                                                <span className="font-semibold">Client:</span> {project.client}
                                            </p>
                                            <p className="text-gray-700">
                                                <span className="font-semibold">Year:</span> {project.year}
                                            </p>
                                            <p className="text-gray-700">
                                                <span className="font-semibold">Duration:</span> {project.duration}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Dots Indicator */}
                {/* <div className="flex justify-center mt-6 space-x-2">
                    {Array.from({ length: Math.ceil(projects.length / itemsToShow) }).map((_, index) => (
                        <button
                            key={index}
                            onClick={() => goToSlide(index * itemsToShow)}
                            className={`h-3 w-3 rounded-full transition-colors ${Math.floor(currentIndex / itemsToShow) === index ? 'bg-[#00A3A1]' : 'bg-gray-300'
                                }`}
                            aria-label={`Go to slide ${index + 1}`}
                        />
                    ))}
                </div> */}
            </div>
        </div>
    );
}